import styles from "components/Form/Form.module.scss";

export const formConfig = {
  did_id: {
    title: "DID",
    elementType: "input",
    elementConfig: {
      id: "did_id",
      type: "text",
      value: "",
      "data-id": "",
      autoComplete: "off",
      placeholder: "Search DID",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: true,
    },
    dropdown: true,
    valid: false,
    touched: false,
    error: {
      message: "DID is required",
    },
  },
  enabled: {
    title: "Is Device Enabled",
    elementType: "select",
    elementConfig: {
      id: "enabled",
      value: true,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    options: [
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    valid: true,
    touched: false,
    error: {
      message: "",
    },
  },
};
